// @ts-nocheck

import palette from '../palette';

export const KLCounter = {
  color: palette.yellowwinamax350,
  colorWarning: palette.orange100,
  colorFatal: palette.red100,
};

export const KLEnrollment = {
  linkColor: palette.yellowwinamax450,
  enrollBtnColor: palette.white,
  enrollBtnBackgroundColor: palette.red200,
};

export const KLBasketBetslipEligible = {
  backgroundColor: palette.klbasketbetslipeligiblebg,
  color: palette.bluegrey925,
};

export const KLBadgeDetails = {
  highlightColor: palette.yellowwinamax450,
};

export const KLNotification = {
  highlightColor: palette.yellowwinamax450,
  colorSuccess: palette.greenwinamax600,
};

export const KLNotificationViewer = {
  skipAllBtn: {
    color: palette.black,
    backgroundColor: palette.white,
  },
  nextBtn: {
    color: palette.white,
    backgroundColor: palette.red200,
  },
  okBtn: {
    color: palette.white,
    backgroundColor: palette.red200,
  },
};

export const KLOrientationPagination = {
  backgroundColor: palette.black,
  zoneSelector: {
    backgroundColorDefault: palette.yellowwinamax450,
    backgroundColorLost: palette.white,
  },
  zoneLabel: {
    colorLost: palette.red100,
    colorDisabled: palette.neutralgrey350,
    colorDefault: palette.yellowwinamax450,
    colorSelectedDefault: palette.black,
  },
};

export const KLHome = {
  opeEndingTagBackgroundColor: palette.red200,
};
